import React from 'react';
import { GlobeIcon, PackageIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
export function FeaturesStrip() {
  return <div className="grid grid-cols-2 gap-[30px] border-b border-t border-[#f0f0f0] bg-white px-5 py-[30px] md:grid-cols-4 md:px-10 md:py-[50px]" data-id="element-41">
      <div className="p-5 text-center" data-id="element-42">
        <div className="mb-3 flex justify-center" aria-hidden="true" data-id="element-43">
          <GlobeIcon className="h-7 w-7 text-[#1a1a1a]" data-id="element-44" />
        </div>
        <div className="mb-[5px] text-[11px] font-bold uppercase tracking-[3px]" data-id="element-45">
          100% Originales
        </div>
        <div className="text-[12px] tracking-[1px] text-[#888]" data-id="element-46">
          Directo de USA, sin intermediarios
        </div>
      </div>

      <div className="p-5 text-center" data-id="element-47">
        <div className="mb-3 flex justify-center" aria-hidden="true" data-id="element-48">
          <PackageIcon className="h-7 w-7 text-[#1a1a1a]" data-id="element-49" />
        </div>
        <div className="mb-[5px] text-[11px] font-bold uppercase tracking-[3px]" data-id="element-50">
          Envíos Nacionales
        </div>
        <div className="text-[12px] tracking-[1px] text-[#888]" data-id="element-51">
          A todo el país, puerta a puerta
        </div>
      </div>

      <div className="p-5 text-center" data-id="element-52">
        <div className="mb-3 flex justify-center" aria-hidden="true" data-id="element-53">
          <MapPinIcon className="h-7 w-7 text-[#1a1a1a]" data-id="element-54" />
        </div>
        <div className="mb-[5px] text-[11px] font-bold uppercase tracking-[3px]" data-id="element-55">
          Local Físico
        </div>
        <div className="text-[12px] tracking-[1px] text-[#888]" data-id="element-56">
          Zona Güemes, Mar del Plata
        </div>
      </div>

      <div className="p-5 text-center" data-id="element-57">
        <div className="mb-3 flex justify-center" aria-hidden="true" data-id="element-58">
          <SparklesIcon className="h-7 w-7 text-[#1a1a1a]" data-id="element-59" />
        </div>
        <div className="mb-[5px] text-[11px] font-bold uppercase tracking-[3px]" data-id="element-60">
          Exclusividad
        </div>
        <div className="text-[12px] tracking-[1px] text-[#888]" data-id="element-61">
          Stock limitado, prendas únicas
        </div>
      </div>
    </div>;
}